import { isNullOrUndefined } from "../utils";
/**
 * Returns a label as a value that can be a code.
 * @example
 * toCode("Hello world"); //"hello_world"
 * toCode("this IS a bunch of values 1"); //"this_is_a_bunch_of_values_1"
 * @export
 * @param {string} label
 * @returns {string} that is code compatible.
 */
export function toCode(label: string, delimeter: string = "_"): string {
	return (label || "")
		.split(/\s+/)
		.filter(s => s.trim() !== "")
		.map(s => s.toLowerCase())
		.join(delimeter);
}

/**
 * Converts a string to Title Case
 *
 * @param {string} input (description)
 * @returns {string} (description)
 */
export function toTitleCase(input: string | undefined | null): string {
	if (isNullOrUndefined(input)) {
		return "";
	}
	return input.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
}

/**
 * Puts the label into a display
 *
 * @export
 * @param {string} label (description)
 * @returns {string} (description)
 */
export function toDisplay(label: string): string {
	return (label || "")
		.split("_")
		.map(Capitalize)
		.join(" ");
}

export function Capitalize(value: string): string {
	if (isNullOrWhitespace(value)) {
		return value;
	}

	return value.slice(0, 1).toUpperCase() + value.slice(1);
}

/**
 * Checks if a string is null or whitespace.
 *
 * @export
 * @param {string} value to check if the value is null or whitespace
 * @returns {boolean} true if it's null, undefined, empty or whitespace else false
 */
export function isNullOrWhitespace(value: string): boolean {
	return (value || "").trim() === "";
}

//TODO : If this gets any bigger use an I18N lib the only reason this function is here becuase it's really small
/**
 * Adds the thousand seperators
 *
 * @export
 * @param {string} value (description)
 * @returns {string} (description)
 */
export function formatCurrency(value: string | number, currency: string = "R"): string {
	let strValue = (typeof value === "number" ? value : parseFloat(value)).toFixed(2);
	return `${currency} ${Number(strValue).toLocaleString("en")}`;
}


// WEBPACK FOOTER //
// ./src/client/utils/string.ts